(() => {
  function init() {
    const offer = document.querySelector('[data-fl-offer-root]');
    if (!offer || offer.dataset.clarityReady === 'true') return;
    offer.dataset.clarityReady = 'true';
    const timer = offer.querySelector('[data-fl-session-timer]');
    if (timer) {
      const output = timer.querySelector('[data-fl-session-time]');
      const key = 'florelle.checkout.session-start.v1';
      let start = Date.now();
      try {
        const stored = Number(sessionStorage.getItem(key));
        if (Number.isFinite(stored) && stored > 0 && stored <= Date.now()) start = stored;
        else sessionStorage.setItem(key,String(start));
      } catch(_) {}
      const deadline = start + 600000;
      function tick() {
        if (!timer.isConnected) return false;
        const seconds = Math.max(0,Math.ceil((deadline - Date.now()) / 1000));
        output.textContent = String(Math.floor(seconds/60)).padStart(2,'0') + ':' + String(seconds%60).padStart(2,'0');
        if (!seconds) {
          timer.querySelector('span strong').textContent = 'Checkout session timer ended';
          timer.querySelector('span small').textContent = 'You may still finish your order at any time.';
          return false;
        }
        return true;
      }
      if(tick()) {
        const interval = setInterval(() => { if (!tick()) clearInterval(interval); },1000);
      }
    }
    const root = offer.querySelector('[data-fl-purchase-clarity]');
    const summary = offer.querySelector('[data-fl-summary-billing]');
    const money = raw => { const a = Number(raw || 0);return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(a/100); };
    function update() {
      const purchase = offer.querySelector('[name="fl-purchase"]:checked')?.value;
      const subscription = purchase === 'subscription';
      const card = offer.querySelector('[name="fl-bundle"]:checked')?.closest('[data-fl-card]');
      if (!card) return;
      const activePlan = !!card.dataset.plan;
      const count = Number(card.dataset.jars)||1;
      const totalText = offer.querySelector('[data-fl-total]')?.textContent?.trim() || '';
      const subCharge = offer.querySelector('[data-fl-summary-price]')?.textContent?.trim() || '';
      const frequencyName = card.dataset.planName || 'your selected Kaching subscription plan';
      const label = offer.querySelector('[data-fl-mode-label]');
      const explanation = offer.querySelector('[data-fl-mode-explanation]');
      const due = offer.querySelector('[data-fl-mode-today]');
      const future = offer.querySelector('[data-fl-mode-future]');
      const futureLabel = offer.querySelector('[data-fl-renewal-label]');
      const frequency = offer.querySelector('[data-fl-mode-frequency]');
      const summaryHeading = offer.querySelector('[data-fl-summary-billing-heading]');
      const summaryDetail = offer.querySelector('[data-fl-summary-billing-detail]');
      root.classList.toggle('is-subscription',subscription);
      root.classList.toggle('is-unavailable',subscription && !activePlan);
      summary.classList.toggle('is-subscription',subscription);
      if (!subscription) {
        label.textContent='ONE-TIME PURCHASE · NO SUBSCRIPTION';
        explanation.textContent='You are paying once for one delivery. No automatic renewals, recurring billing or future shipments.';
        due.textContent=totalText+' before taxes';
        future.textContent='$0.00';
        futureLabel.textContent='Future subscription charges';
        frequency.textContent='One delivery only. No ongoing commitment.';
        summaryHeading.textContent='ONE-TIME ORDER — NO AUTO-RENEWAL';
        summaryDetail.textContent='You are not signing up for a subscription. One-time charge only.';
      } else if(!activePlan){
        label.textContent='SUBSCRIBE & SAVE · NOT YET AVAILABLE';
        explanation.textContent='Subscription billing has not been activated. The prices shown in the bundle cards are previews only; no recurring checkout is available.';
        due.textContent='Not active';
        future.textContent='Not active';
        futureLabel.textContent='Recurring payments';
        frequency.textContent='The exact renewal date, frequency and billing price will appear after a real Kaching plan is connected.';
        summaryHeading.textContent='SUBSCRIPTION NOT ACTIVE';
        summaryDetail.textContent='Select One-Time Purchase to order now. No subscription will be created from this preview.';
      } else {
        label.textContent='SUBSCRIBE & SAVE · AUTOMATIC RENEWAL';
        explanation.textContent='This is a recurring subscription. You will pay for the first delivery now and be charged again automatically at the frequency of your selected plan until you cancel.';
        due.textContent=totalText+' before taxes';
        future.textContent=subCharge+' per delivery';
        futureLabel.textContent='Recurring product charge';
        const unit = card.querySelector('[data-fl-unit]')?.textContent?.trim() || money(Number(card.dataset.sub)/count);
        frequency.textContent='Billing schedule: '+frequencyName+'. Approx. '+unit+' per 30-day jar of product. Shipping and taxes are shown at checkout.';
        summaryHeading.textContent='SUBSCRIBE & SAVE — RECURRING';
        summaryDetail.textContent='Next deliveries: '+subCharge+' each, billed according to '+frequencyName+'. The checkout will show the full plan terms.';
      }
    }
    // Current offer logic runs first, then this explanatory block uses its computed values.
    offer.addEventListener('change',()=>queueMicrotask(update));
    update();
    document.addEventListener('shopify:section:load',update);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();